import moduleSlice from '../views/ModuleMaster/store/index';
import roleSlice from '../../src/views/Setup/RoleRights/Role/store/index';
import userSlice from '../../src/views/Setup/User/store/index';
import locationSlice from '../views/Location/store';
import customerslice from '../views/Master/Customer/store';
import companyslice from '../views/Master/Company/store';
import financialyearSlice from '../views/Master/FinancialYear/store';
import currencySlice from '../views/Master/Currency/store';
import taxmasterSlice from '../views/Master/Taxmaster/store';
import categorymasterSlice from '../views/Master/Category/store/index';
import subCategorySlice from '../views/Master/SubCategory/store/index';
import docTypeSlice from '../views/Master/DocType/store/index';
import invoiceslice from '../views/Outward/Invoice/store';
import proposalSlice from '../views/Outward/Proposal/store';
import recordSlice from '../views/Outward/Record/store';
import proformaSlice from '../views/Outward/Proforma/store/index';
import auditLogSlice from '../views/AuditLog/Tabs/AuditLog/store/index';
import loginLogSlice from '../views/AuditLog/Tabs/LoginLog/store/index';
import statementSlice from '../views/Report/BankStatement/store';
import TransistSlice from '../views/Report/Transist/store';
import dashboardSlice from '../views/Dashboard/store/index';

const crudApis = {
    userSlice,
    roleSlice,
    locationSlice,
    moduleSlice,
    customerslice,
    companyslice,
    financialyearSlice,
    currencySlice,
    taxmasterSlice,
    categorymasterSlice,
    subCategorySlice,
    docTypeSlice,
    invoiceslice,
    proposalSlice,
    recordSlice,
    proformaSlice,
    auditLogSlice,
    loginLogSlice,
    statementSlice,
    TransistSlice,
    dashboardSlice
};

export default crudApis;
